import { REFLECTOR_TYPE } from '../../services/test-assigned/testsConfig';
import { TestTypeDisplayValue, TestTypeValue } from '../../services/test-list/types';
import { AGENT_MODEL } from '../device/device';
import { TEMPLATE_MODEL } from '../templates/type';
export const iconConfiguration = [
  {
    tests: [
      { key: TestTypeDisplayValue.Y1564, iconValue: '', imageValue: 'y1564.svg' },
      { key: TestTypeDisplayValue.BERT, iconValue: '', imageValue: 'bert.svg' },
      { key: TestTypeDisplayValue.TRUESPEED, iconValue: 'mdi-speedometer' },
      { key: TestTypeDisplayValue.Y1731, iconValue: '', imageValue: 'y1564.svg' },
      { key: TestTypeDisplayValue.UDP, iconValue: '', imageValue: 'UDP.svg' },
      { key: TestTypeDisplayValue.TWAMP, iconValue: '', imageValue: 'twamp.svg' },
      {
        key: TestTypeDisplayValue.TWAMP_REFLECTOR,
        iconValue: '',
        imageValue: 'twamp-reflector.svg'
      },
      {
        key: TestTypeDisplayValue.TWAMP_LIGHT_REFLECTOR,
        iconValue: '',
        imageValue: 'twamp-reflector.svg'
      },
      { key: REFLECTOR_TYPE.FULL, iconValue: '', imageValue: 'twamp-reflector.svg' },
      { key: REFLECTOR_TYPE.LIGHT, iconValue: '', imageValue: 'twamp-reflector.svg' },
      { key: TestTypeDisplayValue.RFC2544, iconValue: '', imageValue: 'rfc2544.svg' },
      { key: TestTypeDisplayValue.SERVICE_CONTINUITY, iconValue: 'mdi-web' },
      { key: TestTypeDisplayValue.NETWORK_QUALITY, iconValue: 'mdi-lan-connect' },
      { key: TestTypeDisplayValue.VOIP, iconValue: 'mdi-phone-voip' },
      { key: TestTypeDisplayValue.MULTISTEP, iconValue: 'mdi-script-text-outline' },
      { key: TestTypeDisplayValue.HTTP, iconValue: '', imageValue: 'http.svg' },
      { key: TestTypeDisplayValue.FTP, iconValue: '', imageValue: 'ftp.svg' },
      { key: TestTypeValue.Y1564, iconValue: '', imageValue: 'y1564.svg' },
      { key: TestTypeValue.BERT, iconValue: '', imageValue: 'bert.svg' },
      { key: TestTypeValue.TRUESPEED, iconValue: 'mdi-speedometer' },
      { key: TestTypeValue.Y1731, iconValue: '', imageValue: 'y1564.svg' },
      { key: TestTypeValue.UDP, iconValue: '', imageValue: 'UDP.svg' },
      { key: TestTypeValue.HTTP, iconValue: '', imageValue: 'http.svg' },
      { key: TestTypeValue.FTP, iconValue: '', imageValue: 'ftp.svg' },
      { key: TestTypeValue.TWAMP, iconValue: '', imageValue: 'twamp.svg' },
      { key: TestTypeValue.TWAMP_REFLECTOR, iconValue: '', imageValue: 'twamp-reflector.svg' },
      {
        key: TestTypeValue.TWAMP_LIGHT_REFLECTOR,
        iconValue: '',
        imageValue: 'twamp-reflector.svg'
      },
      { key: TestTypeValue.RFC2544, iconValue: '', imageValue: 'rfc2544.svg' },
      { key: TestTypeValue.SERVICE_CONTINUITY, iconValue: 'mdi-web' },
      { key: TestTypeValue.NETWORK_QUALITY, iconValue: 'mdi-lan-connect' },
      { key: TestTypeValue.VOIP, iconValue: 'mdi-phone-voip' },
      { key: TestTypeValue.MULTISTEP, iconValue: 'mdi-script-text-outline' }
    ],
    state: [
      { key: 'Running', iconValue: 'mdi-play-speed', customClass: 'running' },
      { key: 'Queued', iconValue: 'mdi-progress-clock', customClass: 'queued' },
      { key: 'Ready', iconValue: 'mdi-progress-clock', customClass: 'queued' },
      { key: 'Starting', iconValue: 'mdi-progress-clock', customClass: 'queued' },
      { key: 'Scheduled', iconValue: 'mdi-progress-clock', customClass: 'queued' },
      { key: 'Failed', iconValue: 'mdi-alert-circle-outline', customClass: 'failed' },
      { key: 'Stopped', iconValue: 'mdi-alert-circle-outline', customClass: 'stopped' },
      { key: 'Stopping', iconValue: 'mdi-alert-circle-outline', customClass: 'stopped' },
      { key: 'Finished', iconValue: 'mdi-check-circle-outline', customClass: 'finished' },
      { key: 'Cancelled', iconValue: 'mdi-minus-circle-outline', customClass: 'cancelled' },
      { key: 'Aborted', iconValue: 'mdi-minus-circle-outline', customClass: 'cancelled' },
      { key: 'Lost', iconValue: 'mdi-minus-circle-outline', customClass: 'cancelled' }
    ],
    ATWebListActions: [
      { key: 'RUNNING', iconValue: 'mdi-play-speed', customClass: 'running' },
      { key: 'QUEUED', iconValue: 'mdi-progress-clock', customClass: 'queued' },
      { key: 'FAILED', iconValue: 'mdi-alert-circle-outline', customClass: 'failed' },
      { key: 'STOPPED', iconValue: 'mdi-alert-circle-outline', customClass: 'stopped' },
      { key: 'FINISHED', iconValue: 'mdi-check-circle-outline', customClass: 'finished' }
    ],
    status: [
      { key: 'online', iconValue: 'mdi-circle-medium', customClass: 'online_agent' },
      { key: 'offline', iconValue: 'mdi-circle-medium', customClass: 'offline_agent' },
      { key: 'disabled', iconValue: 'mdi-circle-medium', customClass: 'disabled_agent' },
      { key: 'unregistered', iconValue: 'mdi-circle-medium', customClass: 'unregistered_agent' }
    ],
    uploadsStatus: [
      { key: 'success', iconValue: 'mdi mdi-check-circle-outline', customClass: 'finished' },
      { key: 'failure', iconValue: 'mdi mdi-close-circle-outline', customClass: 'failed' },
      { key: 'skipped', iconValue: 'mdi mdi-minus-circle-outline', customClass: 'stopped' }
    ],
    downloadsStatus: [
      { key: 'Export in progress', iconValue: 'mdi mdi-dots-circle', customClass: 'running' },
      { key: 'error', iconValue: 'mdi mdi-close-circle-outline', customClass: 'failed' },
      { key: 'success', iconValue: 'mdi mdi-check-circle-outline', customClass: 'finished' }
    ],
    inProgress: [
      { key: 'inProgress', iconValue: 'mdi mdi-loading', customClass: 'disabled_agent' }
    ],

    type: [
      {
        key: AGENT_MODEL.WINDOWS,
        iconValue: 'mdi-microsoft-windows',
        imageValue: '',
        customClass: ''
      },
      { key: AGENT_MODEL.VQT, iconValue: 'mdi-server', imageValue: '', customClass: '' },
      {
        key: AGENT_MODEL.HARDWARE,
        iconValue: '',
        imageValue: 'agent_hardware.png',
        customClass: ''
      },
      {
        key: AGENT_MODEL.UNMANAGED,
        iconValue: 'mdi-router-network',
        imageValue: '',
        customClass: ''
      },
      { key: AGENT_MODEL.QT600, iconValue: '', imageValue: 'QT600v2.svg', customClass: '' },
      { key: AGENT_MODEL.MAP2100, iconValue: '', imageValue: 'MAP2100v2.svg', customClass: '' },
      {
        key: AGENT_MODEL.QT600 + ' - P1',
        iconValue: '',
        imageValue: 'QT600v2.svg',
        customClass: ''
      },
      {
        key: AGENT_MODEL.QT600 + ' - P2',
        iconValue: '',
        imageValue: 'QT600v2.svg',
        customClass: ''
      },
      {
        key: AGENT_MODEL.MAP2100 + ' - P1',
        iconValue: '',
        imageValue: 'MAP2100v2.svg',
        customClass: ''
      },
      {
        key: AGENT_MODEL.MAP2100 + ' - P2',
        iconValue: '',
        imageValue: 'MAP2100v2.svg',
        customClass: ''
      },
      { key: AGENT_MODEL.VQT, iconValue: 'mdi-server', imageValue: '', customClass: '' },
      { key: AGENT_MODEL.VTA, iconValue: 'mdi-cube-outline', imageValue: '', customClass: '' },
      { key: AGENT_MODEL.VTA_LB, iconValue: 'mdi-cube-outline', imageValue: '', customClass: '' },
      { key: AGENT_MODEL.VTA_TS, iconValue: 'mdi-cube-outline', imageValue: '', customClass: '' },
      { key: AGENT_MODEL.VPMA, iconValue: 'mdi-cube-outline', imageValue: '', customClass: '' },
      { key: AGENT_MODEL.VPMA_L, iconValue: 'mdi-cube-outline', imageValue: '', customClass: '' },
      { key: AGENT_MODEL.ESAM, iconValue: 'mdi-sitemap-outline', imageValue: '', customClass: '' },
      { key: AGENT_MODEL.NSC, iconValue: '', imageValue: 'agent_hardware.png', customClass: '' },
      { key: AGENT_MODEL.MTS, iconValue: '', imageValue: 'mts.svg', customClass: '' },
      { key: AGENT_MODEL.MTS_5800_100G, iconValue: '', imageValue: 'mts.svg', customClass: '' },
      { key: AGENT_MODEL.MTS_5800V2, iconValue: '', imageValue: 'mts.svg', customClass: '' },
      { key: AGENT_MODEL.MTS_5882, iconValue: '', imageValue: 'mts.svg', customClass: '' },
      { key: AGENT_MODEL.TB_5800_100G, iconValue: '', imageValue: 'mts.svg', customClass: '' },
      { key: AGENT_MODEL.TB_5800v2, iconValue: '', imageValue: 'mts.svg', customClass: '' },
      { key: AGENT_MODEL.TB_5882, iconValue: '', imageValue: 'mts.svg', customClass: '' },
      { key: AGENT_MODEL.TB_MTS_5800_100G, iconValue: '', imageValue: 'mts.svg', customClass: '' },
      { key: AGENT_MODEL.TB_MTS_5800v2, iconValue: '', imageValue: 'mts.svg', customClass: '' },
      { key: AGENT_MODEL.SC4800, iconValue: '', imageValue: 'mts.svg', customClass: '' },
      { key: AGENT_MODEL.SC4800P, iconValue: '', imageValue: 'mts.svg', customClass: '' },
      { key: AGENT_MODEL.VSPA, iconValue: 'mdi-server', imageValue: '', customClass: '' },
      { key: AGENT_MODEL.VSPA_PM, iconValue: 'mdi-server', imageValue: '', customClass: '' },
      { key: AGENT_MODEL.VSPA_PM_L, iconValue: 'mdi-server', imageValue: '', customClass: '' },
      { key: AGENT_MODEL.VSPA_SAT, iconValue: 'mdi-server', imageValue: '', customClass: '' },
      { key: AGENT_MODEL.VSPA_SAT_TS, iconValue: 'mdi-server', imageValue: '', customClass: '' },
      { key: AGENT_MODEL.VSPA_SAT_LB, iconValue: 'mdi-server', imageValue: '', customClass: '' },
      {
        key: AGENT_MODEL.JMEP_1G,
        iconValue: '',
        imageValue: 'jmep.svg',
        customClass: ''
      },
      {
        key: AGENT_MODEL.JMEP_10G,
        iconValue: '',
        imageValue: 'jmep.svg',
        customClass: ''
      },
      { key: 'pc-client', iconValue: '', imageValue: 'pc.svg', customClass: '' }
    ],
    accessLevel: [
      {
        key: TEMPLATE_MODEL.SHARED,
        iconValue: 'mdi-share',
        imageValue: '',
        customClass: 'share-templates'
      },
      {
        key: TEMPLATE_MODEL.PRIVATE,
        iconValue: 'mdi-file-lock',
        imageValue: '',
        customClass: 'private-templates'
      },
      {
        key: TEMPLATE_MODEL.DEFAULT,
        iconValue: 'mdi-star',
        imageValue: '',
        customClass: 'default-templates'
      }
    ]
  }
];

export const actionConfiguration = [
  {
    ActiveTests: [
      {
        key: 'View1',
        label: 'View Running',
        iconValue: 'mdi-play-speed',
        class: 'running',
        isShow: true
      },
      { key: 'Start', label: 'Start', iconValue: 'mdi-play-box', isShow: true },
      { key: 'Stop', label: 'Stop', iconValue: 'mdi-stop', isShow: true },
      { key: 'Edit', label: 'Edit', iconValue: 'mdi-file-document-edit-outline', isShow: true },
      { key: 'Clone', label: 'Clone', iconValue: 'mdi-content-copy', isShow: true },
      {
        key: 'View_running',
        label: 'View Running',
        iconValue: 'mdi-play-speed',
        class: 'running',
        isShow: true
      },
      {
        key: 'View',
        label: 'View Results',
        iconValue: 'mdi-chart-bar',
        class: 'running',
        isShow: true
      },
      {
        key: 'View_reports',
        label: 'View Reports',
        iconValue: 'mdi-file-table-outline',
        isShow: true
      },
      { key: 'Remove', label: 'Remove', iconValue: 'mdi-delete', isShow: true }
    ]
  }
];
